import React, { useMemo } from 'react';
import moment from 'moment';
import user from "../../assets/img/usermiddle.png";
import '../../assets/css/message.css';

const Message = ({ data, isMine }) => {

    const getEmployee = (data) => {
        return data.client || data.manager || data.accountant || data.agent;
    };

    const raiseInvoiceClicked = (url) => {
        localStorage.setItem("pageData", "Data Retrieved from axios request");
        window.open(url, "_blank");
    };

    const fileName = (file) => {
        let nameList = file ? file.split("/") : [];
        return nameList[nameList.length - 1];
    };

    const employee = useMemo(() => getEmployee(data), [data]);

    return (
        <div>
            <div className="conversation-info"/>
            <div className={['conversation-list-item', isMine ? 'my-message' : ''].join(' ')}>
                <div className='created_date'>{moment(data.created_date).format('lll')}</div>
                <h1 className="conversation-title">{employee.user.first_name}</h1>
                <div className='photo-name'>
                    <img
                        className="conversation-photo"
                        src={employee.image ? employee.image : user}
                        alt="img"
                    />
                    <div style={{display:"contents"}} className={['message', isMine ? 'mine' : ''].join(' ')}>
                        <div className="bubble-container">
                            {data.text && (
                                <div className="bubble">{data.text}</div>
                            )}
                            {data.file && (data.file.includes(".jpg") || data.file.includes(".jpeg") || data.file.includes(".png")) ? (
                                <div
                                    className="sms-img"
                                    onClick={() => raiseInvoiceClicked(data.file)}
                                    style={{ backgroundImage: `url(${data.file})` }}
                                />
                            ) : data.file ? (
                                <div onClick={() => raiseInvoiceClicked(data.file)}>
                                    {data.file_name || fileName(data.file)}
                                </div>
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>

            <div className={['message', isMine ? 'mine' : ''].join(' ')}>
                <div className="bubble-container"/>
            </div>
        </div>
    );
};

export default Message;
